import { Component, OnInit } from '@angular/core';
import { MAINTENANCE_GROUP_MASTER_FOLDERNAME, MAINTENANCE_GROUP_MAPPING_FOLDERNAME } from "src/app/utils/constant";
import { GroupMaintenanceFilterComponent } from './group-maintenance-filter/group-maintenance-filter.component';
import { GrpMntDetailModalComponent } from './grp-mnt-detail-modal/grp-mnt-detail-modal.component';
import { DialogService, LanguageService, HelperService } from 'src/app/services';
import { GroupMaintenanceService } from './group-maintenance.service';
import { environment } from 'src/environments/environment';
import { of as observableOf, Subscription } from 'rxjs';
import { MediaObserver } from '@angular/flex-layout';
import { catchError, finalize } from 'rxjs/operators';
import { MatDialogRef } from '@angular/material/dialog';
import * as _ from 'lodash';
 
@Component({
  selector: 'esc-group-maintenance',
  templateUrl: './group-maintenance.component.html',
  styleUrls: ['./group-maintenance.component.scss']
})
 
export class GroupMaintenanceComponent implements OnInit {
  public loading = {
    init: false,
    detail: false,
    more: false,
    export: false,
    import: false,
    error: false,
    detailError: false,
  }
  private listSub: Subscription;
  private detailSub: Subscription;
  public listData = [];
  public detailData;
  public columns = ["code", "description", "is_active"];
  public uploadTemplateColumns1 = ["GROUP CODE", "GROUP NAME", "GROUP TYPE CODE", "GROUP TYPE NAME", "DISTRICT CODE", "DISTRICT NAME", "ISLAND GROUP CODE", "ISLAND GROUP NAME", "STATUS"];
  public uploadTemplateColumns2 = ["GROUP CODE", "GROUP NAME", "WEB USER USERNAME", "WEB USER FULLNAME", "RECIPIENT REFERENCE CODE", "RECIPIENT FULLNAME", "STATUS"];
  public detailKeys = ["code", "description", "island_group_description", "group_type_description", "district_description", "is_active"];
  private currentFilters;
  private previousFilters;
  public listLength = 0;
  public mode;
  public modifying: Boolean = false;
  public deselect: Boolean = false;
  networkErrMsg = this.languageService.getTranslation("MSG_ERROR_NETWORK_CONNECTION", {});
  public folderName1 = MAINTENANCE_GROUP_MASTER_FOLDERNAME;
  public folderName2 = MAINTENANCE_GROUP_MAPPING_FOLDERNAME;
 
  constructor(
    public media: MediaObserver,
    private groupMntSvc: GroupMaintenanceService,
    private dialogService: DialogService,
    private languageService: LanguageService,
    private helper: HelperService
  ) { }
 
  ngOnInit() {
    this.currentFilters = _.cloneDeep(INITIAL_OPTIONS);
    this.getListData();
  }
 
  download(ev) {
    let dialogRef = this.dialogService.loading();
    this.listSub = this.groupMntSvc.genericMaintenanceDownload(this.currentFilters, ev).pipe(
      finalize(() => {
        this.loading.init = false;
        this.loading.more = false;
        return observableOf(null);
      }),
      catchError((err) => {
        if (this.listData.length == 0) {
          this.loading.error = true;
        } else {
          this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_INTERNAL_SERVER_ERROR", {}));
          this.currentFilters.web_filter.offset -= this.currentFilters.web_filter.limit;
        }
        return observableOf(null);
      }))
      .subscribe((res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }
        if (!res || res.status == 0 || res.status == 504 || res.status == 500) {
          this.loading.error = true;
          this.listData = [];
          this.listLength = 0;
          this.dialogService.openSnackBar(this.networkErrMsg);
          return;
        }
        if (_.has(res, 'value') && (_.toLower(res.value) == _.toLower("Success"))) {
          this.helper.openDownloadMenu(res.data);
          dialogRef.close();
        }
      });
  }

  getListData() {
    if (this.listSub && !this.listSub.closed) {
      this.listSub.unsubscribe();
    }
    if (this.loading.init == true) {
      return;
    }
    this.loading.error = false;
    if (this.listData.length == 0) {
      this.loading.init = true;
    } else {
      this.loading.more = true;
    }

    this.listSub = this.groupMntSvc.getList(this.currentFilters).pipe(
      finalize(() => {
        this.loading.init = false;
        this.loading.more = false;
        return observableOf(null);
      }),
      catchError((err) => {
        if (this.listData.length == 0) {
          this.loading.error = true;
        } else {
          this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_INTERNAL_SERVER_ERROR", {}));
          this.currentFilters.web_filter.offset -= this.currentFilters.web_filter.limit;
        }
        return observableOf(null);
      }))
      .subscribe((res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }
        if (!res || res.status == 0 || res.status == 504 || res.status == 500) {
          this.loading.error = true;
          this.listLength = 0;
          this.dialogService.openSnackBar(this.networkErrMsg);
          return;
        }
        if (_.has(res, 'value') && (_.toLower(res.value) == _.toLower("Success"))) {
          this.listData = this.listData.concat(res.data);
          this.listLength = _.toNumber(_.get(res, "count"));
          
          if (this.detailData) {
            this.getDetail(this.detailData)
          }
        } else {
          this.listData = [];
        }
      });
  }
 
  getMore(event) {
    if (this.loading.more || this.loading.init || this.listData.length >= this.listLength) {
      return;
    }
    if (event) {
      this.currentFilters.web_filter.offset += this.currentFilters.web_filter.limit;
      this.getListData();
    }
  }
 
  getDetail(data) {
    if(data) {
      let temp = this.listData.filter(e => {
        return e.id == data.id;
      })
      this.detailData = _.clone(temp[0]);
      this.deselect = false;
    }
  }
 
  addNew(event) {
    this.closeDetail(null);
    this.modifying = true;
    this.mode = 'Add';
    this.openDetailModal()
  }

  openDetailModal() {
    let dialogRef: MatDialogRef<GrpMntDetailModalComponent>;
    dialogRef = this.dialogService.openDialog(GrpMntDetailModalComponent, {
      width: '50%',
      height: '60%',
      autoFocus: false,
      disableClose: false,
    });
    dialogRef.afterClosed().subscribe((res) => {
      this.closeForm(res);

      if(res) {
        this.refresh(true);
      }
    })
  }
 
  edit(event) {
    this.modifying = true;
  }
 
  searchBy(keyword) {
    this.currentFilters.web_filter.keyword = _.clone(keyword);
    this.refresh(true);
  }

  openFilter(ev) {
    let dialogRef: MatDialogRef<GroupMaintenanceFilterComponent>;
    dialogRef = this.dialogService.openDialog(GroupMaintenanceFilterComponent, {
      width: '500px',
      autoFocus: false,
      disableClose: false,
      data: _.get(this, 'previousFilters') || _.get(this, 'currentFilters')
    });
    dialogRef.afterClosed().subscribe((selectedFilters) => {
      if(selectedFilters) {
        this.previousFilters = _.cloneDeep(selectedFilters);

        this.currentFilters.web_filter.status =  _.get(selectedFilters, 'status.code');
        this.refresh(null);
      }
    })
  }
 
  closeDetail(event) {
    this.detailData = null;
    this.deselect = true;
  }
 
  closeForm(event) {
    this.modifying = false;
    this.mode = null;
    if(event) {
      this.refresh(event);
    }
  }
 
  saving(event) {
    if(event) {
      this.detailData = _.clone(event[0]);
      this.loading.detail = true;
    } else {
      this.loading.detail = false;
    }
  }
 
  refresh(event) {
    if (!event) {
      this.closeDetail(null);
    }
    this.listData = [];
    this.listLength = 0;
    this.currentFilters.web_filter.offset = _.clone(INITIAL_OPTIONS.web_filter.offset);
    this.getListData();
  }
}
 
const INITIAL_OPTIONS = {
  web_filter: {
    limit: 50,
    offset: 0,
    keyword: "",
    end_date: "",
    is_asc: 1,
    status: null
  }
};